import { ViewTokenDataStyle } from '../../styles/ViewTokenDataStyle';

export const stylesCustomButton = {

    button: {
        
        padding: '6px 16px',
        textTransform: 'none',
        backgroundColor: '#7BA238',
        color: 'white',
        '&:hover': {
        backgroundColor: '#5a7d2b',
        },
        ...ViewTokenDataStyle.viewDataButton,
        
    },

};